import menus, { MenuItem } from '@components/PageHeader/menus';
import { useLocation } from 'react-router-dom';

export default function useActiveMenu(): MenuItem | undefined {
  const { pathname } = useLocation();
  const trail = `/${pathname.split('/')[1]}`;

  return menus.menu.find(item => item.href === trail);
}
